/**
 * PrimeVue `ProgressSpinner`: set size via root `style` (width/height) — do not add global CSS
 * that targets `.p-progressspinner`. Theme colours: `gpxPrimeVueTheme` — `components.progressspinner`.
 */
export const PVT_SPINNER_STROKE_WIDTH = '2' as const

export const PVT_SPINNER_STYLE_COMPACT = { width: '1.5rem', height: '1.5rem' } as const

export const PVT_SPINNER_STYLE_MEDIUM = { width: '2.5rem', height: '2.5rem' } as const

export const PVT_SPINNER_STYLE_OVERLAY = { width: '4rem', height: '4rem' } as const
